<template>
  <div>
    <div>
      <el-form :disabled="!isOk" :inline="true" ref="form2">
        <el-form-item>
          <el-button type="primary" @click="handleAdd">新增</el-button>
          <el-button type="primary" @click="handleExport">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div align="center">
      <el-table :data="tableData" ref="dataTable" style="width: 100%">
        <el-table-column type="index" label="序号" width="50"/>
        <el-table-column prop="name" label="名称" width="300" />
        <el-table-column prop="url" label="网址" width="600" show-overflow-tooltip>
          <template slot-scope="scope">
            <a :href="scope.row.url" target="_blank" class="buttonText">{{scope.row.url}}</a>
          </template>
        </el-table-column>
<!--        <el-table-column prop="remark" label="备注" width="280" show-overflow-tooltip/>-->
        <el-table-column label="操作" width="160" align="center">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-edit" @click="handleSet(scope.row)" size="small">修改</el-button>
            <el-button type="text" icon="el-icon-edit" @click="handleDel(scope.row)" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false" width="500px">
        <el-form ref="form" :model="form" label-width="120px">
          <el-row>
            <el-col :span="20">
              <el-form-item label="名称" prop="name" :rules="[{required: true, message: '名称为空'}]">
                <el-input v-model="form.name" maxlength="50" style="width: 280px"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item label="网址" prop="url" :rules="[{required: true, message: '网址为空'}]">
                <el-input v-model="form.url" maxlength="200" style="width: 280px"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item label="备注" prop="remark">
                <el-input v-model="form.remark" maxlength="200" style="width: 280px"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel('form')">取消</el-button>
          <el-button type="primary" v-if="dialogStatus==='add'" @click="add('form')"><span>确定</span></el-button>
          <el-button type="primary" v-if="dialogStatus==='set'" @click="set('form')"><span>确定</span></el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import * as http from '../api/http'
import * as util from '../util/util'
import global from '../components/Global'

export default {
  name: 'Tools',
  data () {
    return {
      isOk: false,
      dialogStatus: '',
      dialogTitle: '',
      dialogVisible: false,
      param: {},
      tableData: [],
      form: {}
    }
  },
  created () {
    if (global.uid <= 0 || global.token === '') {
      this.$router.push('/')
      return
    }
    this.list()
  },
  mounted () {
    // setInterval(this.getHeight, 100)
  },
  computed: {
    // src () {
    //   return 'http://fujzz.bj01.bdysite.com/tools/'
    // }
  },
  methods: {
    cancel () {
      this.dialogVisible = false
    },
    add (formName) {
      const set = this.$refs
      set[formName].validate(valid => {
        this.form.uid = this.param.uid
        this.form.token = this.param.token
        http.post(global.url0 + 'nsy-tools/add/', this.form).then(
          res => {
            if (res.code === 200) {
              this.dialogVisible = false
              this.$message.success('新增成功')
              this.list()
            } else {
              this.$message.error('新增失败:' + res.msg)
            }
          }
        )
      })
    },
    set (formName) {
      const set = this.$refs
      set[formName].validate(valid => {
        this.form.uid = this.param.uid
        this.form.token = this.param.token
        http.post(global.url0 + 'nsy-tools/set/', this.form).then(
          res => {
            if (res.code === 200) {
              this.dialogVisible = false
              this.$message.success('修改成功')
              this.list()
            } else {
              this.$message.error('修改失败:' + res.msg)
            }
          }
        )
      })
    },
    handleAdd () {
      this.form = {}
      this.dialogStatus = 'add'
      this.dialogTitle = '新增'
      this.dialogVisible = true
    },
    handleSet (row) {
      this.form = JSON.parse(JSON.stringify(row))
      this.dialogStatus = 'set'
      this.dialogTitle = '修改'
      this.dialogVisible = true
    },
    handleDel (row) {
      this.$confirm('此操作将永久删除记录，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.form = {}
        this.form.uid = this.param.uid
        this.form.token = this.param.token
        this.form.id = row.id
        http.post(global.url0 + 'nsy-tools/del/', this.form).then(
          res => {
            if (res.code === 200) {
              this.$message.success('删除成功')
              this.list()
            } else {
              this.$message.error('删除失败:' + res.msg)
            }
          }
        )
      })
    },
    list () {
      this.isOk = false
      this.tableData = []
      http.post(global.url0 + 'nsy-tools/get/', this.param).then(
        res => {
          let resStr = res.data.toString
          if (resStr.length > 0 && !String.startsWith(resStr, '[')) {
            this.$message.error(res)
            return
          }

          let list = res.data
          for (let i = 0; i < list.length; i++) {
            if (list[i].url.indexOf('://') < 0) { // } (!String.startsWith(list[i].url, 'http')) {
              list[i].url = 'http://milkfans.cn/tools/' + list[i].url
            }
          }
          this.tableData = list
          this.isOk = true
        }
      )
    },
    handleExport () {
      util.toExcel(this.$refs.dataTable.columns, this.tableData, 'Tools')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/views/Tools.vue